/* ZP — Seal Subscriptions widget enhancements.
   Loaded only on Shirataki/Risino PDPs via zp-seal-badge.liquid.
   The Seal widget injects asynchronously, so we poll briefly for it, then:
   1. ALWAYS: add .zp-seal-cardified to the option rows' parent so
      zp-seal-css.liquid can lay the two purchase options out as equal cards
      (widget absent or DOM changed → class never lands → stock rendering).
   2. OPTIONALLY: pre-select the subscription option — only when the
      "ZP Subscriptions → Pre-select subscription" theme setting is on, or
      with ?zpseal=preselect for demos (setting ships OFF: pre-selecting a
      recurring charge needs explicit client sign-off). */
(function () {
  var badge = document.querySelector('[data-zp-seal-badge]');
  if (!badge) return;
  var preselect = badge.getAttribute('data-preselect') === 'true' ||
    /[?&]zpseal=preselect/.test(location.search);

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    var rows = document.querySelectorAll('.sealsubs-target-element .sls-option-container');
    if (rows.length > 1) {
      clearInterval(timer);

      if (rows[0].parentElement) {
        rows[0].parentElement.classList.add('zp-seal-cardified');
      }

      if (preselect) {
        var radio = document.querySelector(
          '.sealsubs-target-element input.sls-option[data-type="subscription"]'
        );
        if (radio && !radio.checked) {
          // Click the role=radio wrapper — Seal listens there, not on the input.
          var wrap = radio.closest('[role="radio"]') || radio;
          wrap.click();
        }
      }
    } else if (tries > 40) {
      clearInterval(timer); // widget never appeared (e.g. preview theme)
    }
  }, 250);
})();
